.featured {
  margin-bottom: var(--space-5);
}

.spotlightGroup {
  display: grid;
  gap: var(--space-4);
  margin-bottom: var(--space-6);
}

.spotlight {
  border-color: var(--color-accent-muted, var(--color-border));
  background: linear-gradient(
    135deg,
    var(--color-bg-muted) 0%,
    var(--color-bg) 100%
  );
}

.spotlightHeader {
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-4);
  border-bottom: 1px solid var(--color-border);
}

.spotlightHeader h3 {
  font-family: var(--font-sans);
  font-size: 1.15rem;
  font-weight: 620;
  margin-bottom: var(--space-1);
}

.spotlight .logo {
  width: 44px;
  height: 44px;
}

.featuredHeader {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-4);
  border-bottom: 1px solid var(--color-border);
}

.featuredHeader h3 {
  font-family: var(--font-sans);
  font-size: 1.25rem;
  font-weight: 620;
  margin-bottom: var(--space-1);
}

.featuredHeader a {
  color: inherit;
  text-decoration: none;
}

.featuredHeader a:hover {
  color: var(--color-accent);
}

.roleTitle {
  font-weight: 500;
  color: var(--color-text-secondary);
}

.progression {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 0.85rem;
  color: var(--color-accent);
  font-weight: 520;
}

.progressionDates {
  margin: var(--space-1) 0 0;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--color-text-muted);
  font-weight: 450;
  line-height: 1.45;
}

.teamSize {
  margin: var(--space-1) 0 0;
  font-size: 0.88rem;
  color: var(--color-text-muted);
}

.featuredMeta {
  font-family: var(--font-mono);
  font-size: 0.85rem;
  color: var(--color-text-muted);
}

.featuredMeta p {
  margin: 0;
  color: var(--color-text-muted);
}

.featuredSummary {
  font-size: 1.02rem;
  color: var(--color-text);
  margin-bottom: var(--space-4);
}

.impactBullets {
  margin: 0 0 var(--space-5);
  padding-left: 1.2rem;
  color: var(--color-text-secondary);
  line-height: 1.65;
}

.impactBullets > li + li {
  margin-top: var(--space-3);
}

.accordions {
  display: grid;
  gap: var(--space-2);
}

.accordion {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background: var(--color-bg-muted);
  transition: border-color var(--duration-fast) var(--ease-out);
}

.accordion summary {
  cursor: pointer;
  padding: var(--space-3) var(--space-4);
  font-weight: 560;
  font-size: 0.92rem;
  color: var(--color-text);
  min-height: 2.75rem;
  display: flex;
  align-items: center;
  transition: color var(--duration-fast) var(--ease-out);
}

.accordion summary:hover {
  color: var(--color-accent);
}

.accordionBody {
  padding: 0 var(--space-4) var(--space-4);
}

.linkRow {
  list-style: none;
  padding: 0;
  margin: var(--space-3) 0 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3) var(--space-4);
}

.linkRow > li {
  margin: 0;
  display: flex;
  align-items: center;
}

.linkRow > li + li {
  margin-top: 0;
}

.linkRow a {
  font-weight: 520;
  font-size: 0.92rem;
}

.timeline {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: var(--space-4);
}

.timeline > li {
  margin: 0;
}

.timeline > li + li {
  margin-top: 0;
}

.timelineItem {
  display: grid;
  gap: var(--space-4);
  padding-bottom: var(--space-4);
  border-bottom: 1px solid var(--color-border);
}

.timelineItem:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.timelineMeta {
  font-family: var(--font-mono);
  font-size: 0.82rem;
}

.dates {
  margin: 0;
  color: var(--color-text);
  font-weight: 520;
}

.location {
  margin: var(--space-1) 0 0;
  color: var(--color-text-muted);
}

.companyRow {
  display: flex;
  gap: var(--space-3);
  align-items: flex-start;
  margin-bottom: var(--space-3);
}

.companyRow h3 {
  margin-bottom: var(--space-1);
  font-size: 1.05rem;
}

.companyRow a {
  color: inherit;
  text-decoration: none;
}

.companyRow a:hover {
  color: var(--color-accent);
}

.logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
  flex-shrink: 0;
}

.featured .logo {
  width: 48px;
  height: 48px;
}

.role {
  margin: 0;
  font-size: 0.92rem;
  color: var(--color-text-muted);
}

.techToggle,
.highlightsToggle {
  margin-top: var(--space-3);
}

.highlightsToggle summary,
.techToggle summary {
  cursor: pointer;
  font-family: var(--font-mono);
  font-size: 0.78rem;
  color: var(--color-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-height: 2rem;
}

.highlightsToggle ul {
  margin: var(--space-3) 0 0;
}

@media (min-width: 768px) {
  .featuredHeader {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  .featuredMeta {
    text-align: right;
    flex-shrink: 0;
  }

  .timelineItem {
    grid-template-columns: 11rem 1fr;
    gap: var(--space-5);
  }
}

@media (hover: hover) and (pointer: fine) {
  .accordion:hover {
    border-color: var(--color-accent);
  }
}

@media (prefers-reduced-motion: reduce) {
  .accordion {
    transition: none;
  }
}
